import React from 'react';
import { Bitcoin, Feather as Ethereum, DollarSign, Mail } from 'lucide-react';
import Logo from './logo';
import { useLanguage } from '../contexts/language-context';

const Footer = () => {
  const { t, getApiDocsUrl, getUrl } = useLanguage();

  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = `mailto:${process.env.GATSBY_SUPPORT_EMAIL}`;
  };

  return (
    <footer className="bg-gray-50 dark:bg-dark text-gray-900 dark:text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div>
            <Logo className="mb-4" />
            <p className="text-gray-600 dark:text-gray-400">{t('footer.tagline')}</p>
            <button 
              onClick={handleContactClick}
              className="mt-4 inline-flex items-center space-x-2 text-neon-green-light dark:text-neon-green hover:opacity-80 transition-opacity"
            >
              <Mail className="w-5 h-5" />
              <span>{t('footer.contact')}</span>
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h4 className="text-lg font-semibold mb-4">{t('footer.service')}</h4>
              <ul className="space-y-2">
                <li>
                  <a 
                    href={getApiDocsUrl()}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 dark:text-gray-400 hover:text-neon-green-light dark:hover:text-neon-green transition-colors"
                  >
                    {t('footer.apiDocs')}
                  </a>
                </li>
                <li>
                  <a 
                    href={getUrl("/aml")}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 dark:text-gray-400 hover:text-neon-green-light dark:hover:text-neon-green transition-colors"
                  >
                    AML
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">{t('footer.documents')}</h4>
              <ul className="space-y-2">
                <li>
                  <a 
                    href={getUrl("/privacy-policy")}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 dark:text-gray-400 hover:text-neon-green-light dark:hover:text-neon-green transition-colors"
                  >
                    {t('footer.privacy')}
                  </a>
                </li>
                <li>
                  <a 
                    href={getUrl("/agreement")}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 dark:text-gray-400 hover:text-neon-green-light dark:hover:text-neon-green transition-colors"
                  >
                    {t('footer.terms')}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-200 dark:border-dark-lighter pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex space-x-4 mb-4 md:mb-0">
              <Bitcoin className="w-6 h-6 text-neon-yellow-light dark:text-neon-yellow" />
              <Ethereum className="w-6 h-6 text-neon-green-light dark:text-neon-green" />
              <DollarSign className="w-6 h-6 text-neon-yellow-light dark:text-neon-yellow" />
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              {t('footer.copyright')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;